import { useMultiStyleConfig } from '@chakra-ui/react';
import { type ReactNode } from 'react';
import { Icon, IconName, IconProps } from '../../../../atoms';
import { useStatusCardRootContext } from '../root/status-card-context';

type StatusCardIndicatorProps = Omit<IconProps, 'name'> & {
  name?: IconName;
};

export function StatusCardIndicator({
  name,
  ...props
}: StatusCardIndicatorProps): ReactNode {
  const { variant } = useStatusCardRootContext();
  const defaultName = useDefaultIconName();
  const styles = useMultiStyleConfig('StatusCard', { variant });

  return (
    <Icon
      __css={styles.indicator}
      name={name ?? defaultName}
      width="20px"
      height="20px"
      {...props}
    />
  );
}

function useDefaultIconName(): IconName {
  const { variant } = useStatusCardRootContext();

  switch (variant) {
    case 'warning':
      return IconName.WarningRound;
    case 'alert':
      return IconName.Error;
    case 'success':
      return IconName.Success;
  }
}
